import RedirectButton from './component';
import { RedirectButtonProps } from './types';

export default RedirectButton;
export type { RedirectButtonProps };
